import { NgModule } from '@angular/core';
import { CoreCommonModule } from 'src/@core/common.module';
import { CoreMenuModule } from 'src/@core/components';
import { HorizontalMenuComponent } from './horizontal-menu.component';


@NgModule({
  declarations: [HorizontalMenuComponent],
  imports: [CoreMenuModule, CoreCommonModule],
  exports: [HorizontalMenuComponent]
})
export class HorizontalMenuModule {}
